import AutoTwoColumnLayoutViewModelT from '@/ViewModels/Controls/AutoTwoColumnLayoutViewModel';
import AsyncLayoutFactory from '@/Factories/AsyncLayoutFactory';
import ComponentManager from '@/Management/ComponentManager';
import AutoTwoColumnLayout from '@/Controls/AutoTwoColumnLayout';

export default class AutoTwoColumnLayoutFactory extends AsyncLayoutFactory {
    public viewModel: AutoTwoColumnLayoutViewModelT;
    private jQueryControl: JQuery;
    private control: AutoTwoColumnLayout;
    private AutoTwoColumnLayoutViewModel = ComponentManager.getViewModel<typeof AutoTwoColumnLayoutViewModelT>('AutoTwoColumnLayoutViewModel');
    private AutoTwoColumnLayout = ComponentManager.getControl<typeof AutoTwoColumnLayout>('AutoTwoColumnLayout');

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.viewModel = new this.AutoTwoColumnLayoutViewModel({
            tuples: this.tuples,
            labelColumnWidth: this.context.labelColumnWidth
        });
        this.control = new this.AutoTwoColumnLayout(this.viewModel);
        const tuple = await this.control.getTupleAsync();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('AutoTwoColumnLayout', AutoTwoColumnLayoutFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');